import { render, staticRenderFns } from "./cropProductionFertilizer.vue?vue&type=template&id=efb7ad50&scoped=true"
import script from "./cropProductionFertilizer.vue?vue&type=script&lang=js"
export * from "./cropProductionFertilizer.vue?vue&type=script&lang=js"
import style0 from "./cropProductionFertilizer.vue?vue&type=style&index=0&id=efb7ad50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb7ad50",
  null
  
)

export default component.exports